"use client"

import { Italic } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ItalicIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ItalicIcon = component(Icon)({ as: Italic })
